import type { CMSConfig } from '#types/config/components/cms'

export default {
  allowMixBlendMode: true,
  maxPromoMessages: 4
} satisfies CMSConfig['promoBar']
